import { alpha, Theme } from '@mui/material';

export default {
    container: {
        flexGrow: 1,
        minHeight: 0,
    },
    searchBar: {
        flexShrink: 0,
        px: 2,
        py: 1,
        borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    },
    chatList: {
        flexGrow: 1,
        overflow: 'auto',
        position: 'relative',
        px: 2,
        py: 1.5,
    },
    groupTitle: {
        fontSize: '11px',
        lineHeight: '18px',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.8),
        mb: 0.5,
    },
    empty: {
        fontSize: '12px',
        color: 'text.secondary',
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mx: -2,
        px: 2,
        minHeight: '29px',
        '&:hover, &.menu-open': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
        },
        '&:hover .recent-chat-kebab, &.menu-open .recent-chat-kebab, &:focus-within .recent-chat-kebab': {
            opacity: 1,
        },
    },
};
